/**
 * Extração de resumo rápido a partir dos campos preenchidos.
 */
export interface QuickSummaryItem {
  label: string;
  value: string;
}

const PRIORITY_PATTERNS = [
  /pedido/i,
  /ordem/i,
  /quantidade/i,
  /qtd/i,
  /cliente/i,
  /material/i,
  /conforme/i,
  /lote/i,
  /nota\s*fiscal/i,
  /\bnf\b/i,
  /produto/i,
  /código/i,
  /codigo/i,
];

function formatFieldValue(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
  if (typeof value === 'number') return String(value);
  const str = String(value).trim();
  return str.length > 0 ? str : null;
}

function priorityScore(label: string): number {
  const idx = PRIORITY_PATTERNS.findIndex((pattern) => pattern.test(label));
  return idx >= 0 ? PRIORITY_PATTERNS.length - idx : 0;
}

export function extractFormQuickSummary(
  fields: Array<{ id: string; label: string }>,
  formState: Record<string, unknown>,
  maxItems = 4,
): QuickSummaryItem[] {
  const candidates = fields
    .map((field) => {
      const value = formatFieldValue(formState[field.id]);
      if (!value) return null;
      return {
        label: field.label,
        value,
        score: priorityScore(field.label),
      };
    })
    .filter((item): item is NonNullable<typeof item> => item !== null)
    .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label, 'pt-BR'));

  return candidates.slice(0, maxItems).map(({ label, value }) => ({ label, value }));
}
